$(".testimonial-img > a").each(function () {
  $(this).find("img").hide();
  var _Bg = "url(" + $(this).find("img").attr("src") + ")";
  $(this).css("background-image", _Bg);
  $(this).find("img").hide();
});

$(document).click(function (event) {
  if (!$(event.target).closest(".select-size, .select-size + .mak-ul").length) {
    $(".mak-ul").hide(500);
    $(".select-size").removeClass("up");
  }
});
$(".staticswatches .select-size").click(function (event) {
  event.stopPropagation();
  $(this).next(".mak-ul").toggle(500);
  $(this).toggleClass("up");
});

$(".modal-open").click(function () {
  $(".cart_quick_modal").addClass("show");
});
$(".quick-cart-overlay, .close-btn-q, .close-btn-qm").click(function () {
  $(".cart_quick_modal").removeClass("show");
});

$(".newdiv .swatch-element ").click(function () {
  $(".select-size").next("ul").slideUp(500);
  $(".select-size").removeClass("up");
  $(this).parents(".newdiv").find("#value").html($(this).text());
  $(this).parents(".newdiv").find("#value").val($(this).data("value"));
});

window.onload = function () {
  const radioButtons = document.querySelectorAll('input[name="option-1"]');
  const displayDiv = document.getElementById("value");

  // Function to get the value of the checked radio button
  function getCheckedValue() {
    for (const radioButton of radioButtons) {
      if (radioButton.checked) {
        return radioButton.value;
      }
    }
  }

  // Display the checked value on page load
  displayDiv.textContent = `${getCheckedValue()}`;

  // Optional: Update display when the selection changes
  radioButtons.forEach((radioButton) => {
    radioButton.addEventListener("change", function () {
      displayDiv.textContent = `${getCheckedValue()}`;
    });
  });
};

$(".overlay").click(function () {
  $("body").removeClass("no-scroll");
  $("body").removeClass("cart-open");
  $(".g_side_cart ").removeClass("active");
});

$(".new-arrivals-slide").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 3,
  centerMode: true,
  centerPadding: "100px",
  prevArrow:
    '<button type="button" class="arrow-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0658/9864/3695/t/33/assets/prevarrow.svg?v=1716379767" alt=""></button>',
  nextArrow:
    '<button type="button" class="arrow-next pull-right"><img src="nextarrow.svg" alt=""></button>',
  responsive: [
    {
      breakpoint: 992,

      settings: {
        slidesToShow: 3,
      },
    },

    {
      breakpoint: 767,

      settings: {
        slidesToShow: 2,

        centerPadding: "50px",
      },
    },

    {
      breakpoint: 480,

      settings: {
        slidesToShow: 1,

        centerPadding: "50px",
      },
    },
  ],
});

$(".testimonials-row").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "200px",
  prevArrow:
    '<button type="button" class="arrow-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0658/9864/3695/t/33/assets/prevarrow.svg?v=1716379767" alt=""></button>',
  nextArrow:
    '<button type="button" class="arrow-next pull-right"><img src="nextarrow.svg" alt=""></button>',
  responsive: [
    {
      breakpoint: 767,

      settings: {
        centerPadding: "50px",
      },
    },
  ],
});

$(".annc-slidess").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
});

$(".brands-row").slick({
  infinite: true,
  slidesToShow: 7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,

      settings: {
        slidesToShow: 4,
      },
    },

    {
      breakpoint: 767,

      settings: {
        slidesToShow: 3,
      },
    },

    {
      breakpoint: 480,

      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

if ($(window).width() <= 767) {
  $(".shop-category-row").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="arrow-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0658/9864/3695/t/33/assets/prevarrow.svg?v=1716379767" alt=""></button>',
    nextArrow:
      '<button type="button" class="arrow-next pull-right"><img src="nextarrow.svg" alt=""></button>',
    responsive: [
      {
        breakpoint: 480,

        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".latest-blog-row").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="arrow-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0658/9864/3695/t/33/assets/prevarrow.svg?v=1716379767" alt=""></button>',
    nextArrow:
      '<button type="button" class="arrow-next pull-right"><img src="nextarrow.svg" alt=""></button>',
    responsive: [
      {
        breakpoint: 640,

        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    cssEase: "linear",
    arrows: false,
    dots: false,
    asNavFor: ".pro-img-slide",
    focusOnSelect: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 6,
        },
      },

      {
        breakpoint: 480,

        settings: {
          slidesToShow: 7,
        },
      },
    ],
  });
}

$(".logo-text-slider-row").slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 2000,
  cssEase: "linear",
  infinite: true,
  responsive: [
    {
      breakpoint: 992,

      settings: {
        slidesToShow: 4,
      },
    },

    {
      breakpoint: 767,

      settings: {
        slidesToShow: 3,
      },
    },

    {
      breakpoint: 480,

      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

$(".upsell-slide").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  prevArrow:
    '<button type="button" class="arrow-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0658/9864/3695/t/33/assets/prevarrow.svg?v=1716379767" alt=""></button>',
  nextArrow:
    '<button type="button" class="arrow-next pull-right"><img src="https://cdn.shopify.com/s/files/1/0658/9864/3695/t/33/assets/prevarrow.svg?v=1716379767" alt=""></button>',
  dots: false,
  variableWidth: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,

      settings: {
        slidesToShow: 2,
        arrows: true,
      },
    },

    {
      breakpoint: 480,

      settings: {
        slidesToShow: 2,
        arrows: true,
      },
    },
  ],
});
